module.exports = "//static.hsappstatic.net/LoginUI/static-1.15632/img/hubspotMobileApp2FA.png"